export default __webpack_public_path__ + "static/media/logo-smaller.e935cc98.png";